<template>
   <div>
     <div class="layout-header">
       <div class="header">
         <div class="header-left">Green</div>
         <div class="header-right">
           <ul>
             <router-link to="/show">用户中心</router-link>
             <router-link to="/buy">购买</router-link>
             <router-link to="/line">线路列表</router-link>
           </ul>
         </div>
       </div>
     </div>
     <div class="layout-content" >
       <router-view :key="$router.path"></router-view>
     </div>
     <div class="layout-footer">
       <div>
         <div class="footer">
           <ul>
             <li @click="goTo('/problem')">问题反馈</li>
             <li @click="goTo('/contactus')">联系我们</li>
             <li @click="goTo('/information')">常见问题</li>
             <li @click="ding()">使用指南</li>
           </ul>
         </div>
         <van-dialog v-model:show="show" title="使用指南" confirm-button-text="下一步" confirm-button-color="rgb(36, 104, 242)" :before-close="onBeforeClose">
           <template #title>
             <div class="dialog-title">
               <div class="dialog-info">使用指南</div>
               <div class="dialog-skip" @click="jump">跳过指南</div>
             </div>
           </template>
           <template #default>
             <div class="dialog-default">
               <div>第一步:登录账号后点击“购买”,进入”购买页面，选择任意会员套餐点击购买付款。</div>
               <img src="@/assets/yin1.jpg" />
             </div>
           </template>
         </van-dialog>
         <van-dialog v-model:show="tshow" title="使用指南" confirm-button-text="下一步" confirm-button-color="rgb(36, 104, 242)"
         :before-close="test">
           <template #title>
             <div class="dialog-title">
               <div class="dialog-info">使用指南</div>
               <div class="dialog-skip" @click="jump">跳过指南</div>
             </div>
           </template>
           <template #default>
             <div class="dialog-default">
               <div> 第二步:购买完成后点击“线路列表"，进入线路页面,选择需要链接的线路,点击"获取线路"，即可获得可使用的线路链接。 </div>
               <img src="@/assets/yin2.jpg" />
             </div>
           </template>
         </van-dialog>
         <van-dialog v-model:show="suc" title="使用指南" confirm-button-text="完成" confirm-button-color="rgb(36, 104, 242)"
                     :before-close="test1">
           <template #title>
             <div class="dialog-title">
               <div class="dialog-info">使用指南</div>
               <div class="dialog-skip" @click="jump">跳过指南</div>
             </div>
           </template>
           <template #default>
             <div class="dialog-default">
               <div> 第三步:打开手机中已安装好的"outline"APP(
                 <a href="https://apps.apple.com/us/app/outline-app/id1356177741">点击此处下载</a>)<br>
                 点击 <span @click="line" class="copy-line">获取线路</span>
                 复制线路信息至输入框，点击连接即可享受极致的网络服务!
               </div>
               <img src="@/assets/3.png" />
             </div>
           </template>
         </van-dialog>
       </div>
     </div>
   </div>
</template>
<script>

export default {
  data() {
    return {
      user_id:"123456",
      end_time:"2024-01-22 21:15",
      show:false,
      tshow:false,
      suc:false,
      reload_userinfo:[]
    };
  },
  watch:{
    '$route':'initData'
  },
  methods: {
    initData(){
      // let now_path =  this.$route.path
      // console.log(now_path);
      // if(now_path == '/show'){
      //   this.show = true
      // }
    },
    line(){
       this.goTo('/line')
      this.jump()
    },
    onSubmit(values) {
      console.log('submit', values);
    },
    goTo(path){
      if (path=='/problem'){
        var userinfo = JSON.parse(localStorage.getItem('userinfo'))
        let _this = this
        if(userinfo){
          let url =  'http://kefu.mobileairport.net/chatIndex?kefu_id=kefu8&userid='+userinfo.uid
          window.open(url)
        }else{
          this.$router.push('/login');
        }
        return
      }
      this.$router.push(path);
    },
    ding(){
      this.show = true
    },
    onBeforeClose(action,done){
       this.show = false
       this.tshow = true
       return done(true)

    },
    test(action,done){
      this.tshow = false
      this.suc = true
      return done(true)
    },
    test1(action,done){
       this.suc = false
       return done(true)
    },
    jump(){
      this.show = false
      this.tshow = false
      this.suc = false
    }
  },
  created() {
    // let now_path =  this.$route.path
    // if(now_path == '/show'){
    //   this.show = true
    // }
  },
  mounted() {
    if (location.href.indexOf("#reloaded") == -1) {
      let now_path =  this.$route.path
      if(now_path == '/show'){
        console.log(111);
        this.show = true
      }
      }else{
      console.log(22)
    }
    }
};
</script>
<style scoped>
div{
  display: block;
}
.copy-line{
  color: #2668f3;
}
.header{
  width: 100%;
  position: fixed;
  background-color: #393d41;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-top: 2.666667vw;
  padding-bottom: 2.666667vw;
}
.header-left{
  color: #fff;
  font-size: 4.533333vw;
  font-weight: 800;
  padding: 1.333333vw;
  margin-left: 2.666667vw;
}
.header-right{
  color: #757474;
  font-size: 3.2vw;
  padding: 1.333333vw;
  margin-right: 2.666667vw;
}
.header .header-right ul {
  display: flex;
  align-items: center;
}
.header .header-right ul .router-link-exact-active{
  color: #fff;
}
.header .header-right ul a {
  margin-left: 2.666667vw;
  color: hsla(0,0%,100%,.702);
  font-size: 4vw;
}
.layout-content {
  background-color: #f6f6f6;
}
.index-container .warpper{
  padding: 0 2.666667vw 0 2.666667vw;
  padding-top: 13.333333vw;
  background: #f6f6f6;
}
.index-container .warpper .user-info{
  margin-top: 2.666667vw;
  display: flex;
  flex-direction: column;
  align-items: center;
  background-color: #fff;
}
.index-container .warpper .user-info img{
  width: 20vw;
  height: 20vw;
  border-radius: 50%;
}
.index-container .warpper .user-click{
  margin-top: 2.666667vw;
  background-color: #fff;
}
.index-container .warpper .user-click ul{
  display: flex;
  justify-content: space-around;
}
.index-container .warpper .user-click ul li{
  flex: 1;
  font-size: 4vw;
  font-weight: 700;
  border-right: 0.4vw solid #ccc;
  text-align: center;
  padding: 4vw 2.666667vw 4vw 2.666667vw;
}
.index-container .warpper .user-click ul li:nth-child(2) {
  border-right: none;
}
.index-container .warpper .user-info .user-id{
  margin-top: 2.666667vw;
  font-size: 3.733333vw;
  font-weight: 700;
  margin-bottom: 2.666667vw;
}
.index-container .warpper .my-vip .vip-title{
  margin-top: 2.666667vw;
  font-size: 4vw;
  font-weight: 700;
  margin-bottom: 2.666667vw;
}
i {
  font-size: 4vw;
  color: #c4c9ce;
  padding-right: 1.333333vw;
}
.index-container .warpper .my-vip{
  background-color: #fff;
  padding-left: 2.666667vw;
  padding-right: 2.666667vw;
  padding-bottom: 2.666667vw;
  padding-top: 4vw;
  margin-top: 2.666667vw;
}
.index-container .warpper .my-vip ul .li-active {
  background:url("~@/assets/vip.png") no-repeat;
  background-size: 100% 100%;
}
.index-container .warpper .my-vip ul li .info-item{
  align-items: center;
  font-size: 4.266667vw;
}
.index-container .warpper .my-vip ul li .info-item span {
  margin-left: 1.333333vw;
}
.end-time  {
  font-size: 3.2vw;
}
.index-container .warpper .my-vip ul .li-active .click-button{
  background-color: #b4731c;
}
.index-container .warpper .my-vip ul li {
  background: url("~@/assets/vip.png") no-repeat;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 4vw 2.666667vw 4vw 2.666667vw;
  font-size: 3.2vw;
  margin-bottom: 2.666667vw;
}
.index-container .warpper .my-vip ul li .click-button {
  background-color: #5187f5;
  color: #fff;
  width: 13.333333vw;
  font-size: 3.466667vw;
  text-align: center;
  padding: 1.333333vw 4vw 1.333333vw 2.666667vw;
  border-radius: 4vw;
  margin-right: 4vw;
}
.van-icon {
  position: relative;
  font: normal normal normal 3.733333vw/1 vant-icon;
  font-size: inherit;
  text-rendering: auto;
  -webkit-font-smoothing: antialiased;
}
.index-container .warpper .my-vip ul li {
  background: url("~@/assets/bj1.png") no-repeat;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 4vw 2.666667vw 4vw 2.666667vw;
  font-size: 3.2vw;
  margin-bottom: 2.666667vw;
}
.footer{
  position: fixed;
  bottom: 0;
  width: 100%;
  background-color: #393d41;
}
.footer ul{
  padding: 5.333333vw 2.666667vw 5.333333vw 2.666667vw;
  display: flex;
  justify-content: space-around;
}
.footer ul li{
  font-size: 4vw;
  color: #b2b6ba;
  padding-right: 2.666667vw;
  border-right: 0.533333vw solid #b2b6ba;
  cursor: pointer;
}
.van-dialog {
  position: fixed;
  top: 45%;
  left: 50%;
  width: 85.333333vw;
  overflow: hidden;
  font-size: 4.266667vw;
  background-color: #fff;
  border-radius: 4.266667vw;
  -webkit-transform: translate3d(-50%,-50%,0);
  transform: translate3d(-50%,-50%,0);
  -webkit-backface-visibility: hidden;
  backface-visibility: hidden;
  -webkit-transition: .3s;
  transition: .3s;
  -webkit-transition-property: opacity,-webkit-transform;
  transition-property: opacity,-webkit-transform;
  transition-property: transform,opacity;
  transition-property: transform,opacity,-webkit-transform;
}
.dialog-info{
  font-size: 4.533333vw;
  margin-left: 26.666667vw;
}
 .dialog-skip{
  margin-left: 8vw;
  font-size: 4.266667vw;
  color: #8e8e8c;
}
.dialog-title{
  display: flex;
  font-weight: 800;
  text-align: center;
  font-weight: 700;
}
.van-dialog__content img{
  width: 80%;
  margin-top: 2.666667vw;
  margin-bottom: 2.666667vw;
}
.dialog-default{
  font-size: 4vw;
  margin-top: 5.333333vw;
  text-align: center;
  padding-left: 5.333333vw;
  padding-right: 5.333333vw;
  line-height: 8vw;
}
div {
  display: block;
}
</style>



// WEBPACK FOOTER //
// src/view/home.vue